import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { LocalStorage } from '../helpers/localstorage.helper';
import { jwtDecode } from 'jwt-decode';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {

        const authToken = LocalStorage.get('auth');
        const refreshToken: any = LocalStorage.get('auth')?.refresh_token;

        let decoded: any = '';
        try {
            if (refreshToken)
                decoded = jwtDecode(refreshToken) as any;
            if (!decoded) {
                const id_token: any = LocalStorage.get('auth')?.id_token;
                decoded = jwtDecode(id_token) as any;
            }

        }
        catch (error) {
            const id_token: any = LocalStorage.get('auth')?.id_token;
            if (!!id_token)
                decoded = jwtDecode(id_token) as any;
        }


        if (authToken && (new Date(decoded?.['exp'] * 1000).getTime() > new Date().getTime())) {
            return true;
        } else {
            this.router.navigate(['/auth']);
            return false;
        }



    }
}
